// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".compiled.css?v=" + "c17a9ec0a471b4206363" + "";
};